"use strict";

import "babel-polyfill";

import $ from "jquery";
import "jquery-ui";

// make $ global for external libs (e.g. quirk):
window.jQuery = window.$ = window.jquery = $;

//import 'jointjs/dist/joint.css';
import "jquery-mask-plugin";
import "jquery-knob";
import "jquery-countdown";
import "dropzone";

import "chart.js";
// make Chart global for external libs:
window.Chart = Chart;

import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
//import "bootstrap/dist/css/bootstrap-theme.min.css";

import "./main.css";

// import "bootstrap-treeview/dist/bootstrap-treeview.min.css";
// import "bootstrap-treeview/dist/bootstrap-treeview.min";

import "./components/chart/ChartComponent";
//import "./components/datepicker/DatePicker";
//import "./components/datatable/DataTable";

import "./components/ionslider/Slider";
import 'jquery-ui/ui/widgets/draggable';
import 'jquery-ui/ui/widgets/droppable';
import 'jquery-ui/ui/widgets/resizable';

// window.addEventListener('unhandledrejection', console.error.bind(console, 'unhandledrejection'));



// WEBPACK FOOTER //
// ./src/main.js